export default "__VITE_ASSET__CLXXEcPL__"